import { ReportTemplate as _ReportTemplate } from '@team-milva/lab-models/resources'

export class ReportTemplate extends _ReportTemplate {}
